import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=9b4c1734&"
import script from "./app-header.vue?vue&type=script&lang=js&"
export * from "./app-header.vue?vue&type=script&lang=js&"
import style0 from "./app-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports